import { QueryConnectionsEnum } from "@/enum/queryStatus";
import { z } from "zod";

export const QueryConnectionsSchema = z.object({
  id: z.number().optional(),
  connection_nickname: z.string().optional(),
  connection_name: z.string().min(1, "Nome é obrigatório"),
  connection_url: z.string().url("URL inválida").optional(),
  connection_user: z.string().min(1, "Usuário é obrigatório"),
  connection_pass: z.string().min(1, "Senha é obrigatória"),
  connection_db: z.string().min(1, "Banco de dados é obrigatório"),
  connection_port: z
    .number()
    .int()
    .positive("Porta deve ser um número inteiro positivo")
    .optional(),
  connection_host: z.string().min(1, "Host é obrigatório"),
  connection_type: z.string().optional(),
  connection_status: z
    .enum(Object.values(QueryConnectionsEnum) as [string, ...string[]])
    .optional(),
  select_allowed: z.boolean().optional(),
  updates_allowed: z.boolean().optional(),
});

export type QueryConnections = z.infer<typeof QueryConnectionsSchema>;
